var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ul',[_c('li',{attrs:{"id":"left-container"}},[_c('a',[_c('router-link',{staticClass:"route-btn w-100 bg-transparent",attrs:{"to":{ name : 'clientsside' }}},[_vm._v(" submit ")])],1)]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{attrs:{"id":"right-container"}},[_c('a',{attrs:{"href":"#"}},[_vm._v("View previous loans")])])
}]

export { render, staticRenderFns }